/**
 * ブランド固定ページのメニュー
 * SP は下部バーから全画面メニューを開き、PC は左の固定メニューを使う
 */

const setMenuOpen = (nav: HTMLElement, openButton: HTMLButtonElement, open: boolean): void => {
  nav.classList.toggle("is-open", open);
  openButton.setAttribute("aria-expanded", open ? "true" : "false");
  document.body.classList.toggle("is-brand-menu-open", open);
};

const initMenu = (root: HTMLElement): void => {
  const nav = root.querySelector<HTMLElement>("[data-brand-nav]");
  const openButton = root.querySelector<HTMLButtonElement>("[data-brand-menu-open]");
  const closeButton = root.querySelector<HTMLButtonElement>("[data-brand-menu-close]");
  if (!nav || !openButton) return;

  openButton.addEventListener("click", () => {
    setMenuOpen(nav, openButton, true);
  });

  closeButton?.addEventListener("click", () => {
    setMenuOpen(nav, openButton, false);
  });

  for (const link of Array.from(nav.querySelectorAll("a"))) {
    link.addEventListener("click", () => {
      setMenuOpen(nav, openButton, false);
    });
  }

  document.addEventListener("keydown", (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      setMenuOpen(nav, openButton, false);
    }
  });
};

const isOnScreen = (element: Element): boolean => {
  const rect = element.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
};

// 修正: MVとフッターが画面内にあるあいだ、PCの左メニューを隠す
const initNavVisibility = (root: HTMLElement): void => {
  const nav = root.querySelector<HTMLElement>("[data-brand-nav]");
  const mv = root.querySelector("#brand-top");
  const footer = document.querySelector(".p-footer");
  if (!nav || !mv) return;

  const update = (): void => {
    const footerOnScreen = footer ? isOnScreen(footer) : false;
    nav.classList.toggle("is-nav-hidden", isOnScreen(mv) || footerOnScreen);
  };

  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
};

const initActiveNav = (root: HTMLElement): void => {
  const nav = root.querySelector("[data-brand-nav]");
  if (!nav) return;

  const links = Array.from(nav.querySelectorAll<HTMLAnchorElement>("a[href^='#']"));
  const sections = links
    .map((link) => document.querySelector(link.getAttribute("href") || ""))
    .filter((section): section is Element => section instanceof Element);

  if (sections.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const id = entry.target.id;
        for (const link of links) {
          link.classList.toggle("is-active", link.getAttribute("href") === `#${id}`);
        }
      }
    },
    { rootMargin: "-35% 0px -50% 0px" },
  );

  for (const section of sections) {
    observer.observe(section);
  }
};

export const brandPage = (): void => {
  const root = document.querySelector<HTMLElement>("[data-brand-page]");
  if (!root) return;
  initMenu(root);
  initNavVisibility(root);
  initActiveNav(root);
};
